import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { ReactNode } from 'react';
import { cm } from 'src/utils/classNames';
import RadioGroup from 'src/components/primitives/RadioGroup/RadioGroup';

interface Props<T> {
	label: string;
	value: T;
	onChange: (value: T) => void;
	tooltipContent?: string | ReactNode;
	wrapperClassName?: string;
	labelClassName?: string;
	buttonClassName?: string;
	options: {
		id: string;
		label: string;
		value: T;
		color?: string;
	}[];
	disabled?: boolean;
}

const SettingsButtonGroup = <T extends string>({
	label,
	value,
	options,
	onChange,
	labelClassName,
	tooltipContent,
	wrapperClassName,
	disabled,
}: Props<T>) => {
	return (
		<div
			key={label}
			className={cm('flex items-center justify-between', wrapperClassName)}
		>
			{tooltipContent ? (
				<Tooltip
					className={cm(
						'inline-flex items-center typo-b4 text-text-default',
						labelClassName
					)}
					content={tooltipContent}
				>
					{label}
				</Tooltip>
			) : (
				<span className={cm('typo-b4 text-text-default', labelClassName)}>
					{label}
				</span>
			)}

			<RadioGroup.Default
				variant="card"
				className="gap-x-sm"
				size="md"
				items={options}
				value={value}
				onValueChange={(value) => onChange(value as T)}
				disabled={disabled}
			/>
		</div>
	);
};

export default SettingsButtonGroup;
